import {useNavigate} from "react-router-dom";
import SnackError from "../../components/SnackError";
import React from "react";
import {usePostOperationMutation} from "./operation_api";
import OperationForm from "./OperationForm";
import {Card, CardContent} from "@mui/material";
import Title from "../navigation/Title";
import {TablesInsert} from "../../apitypes";


export const OperationCreate = () => {

    const [post, {
        isLoading: isUpdating,
        error,
        isError,
    }] = usePostOperationMutation();
    const navigate = useNavigate();
    const handleSubmit = async function (values: TablesInsert<"workTask">) {
        const resp = await post( values)
        if ("data" in resp) {
            navigate("..")
        }
    };

    return <>
       <Title title={"Nova operacija"}/>
        <Card sx={{mt: "2em"}}>
            {isError && <SnackError error={error}/>}
            <CardContent>
                <OperationForm
                    isUpdating={isUpdating}
                    onSubmit={handleSubmit}
                    onCancel={() => navigate("..", {replace: true})}
                    object={{Name: "", Code: "",Active:true, Details: "", Rate: 0, NeedsMachine: false, NeedsWorkOrder:true, image_url: ""}}
                />
            </CardContent>
        </Card>
    </>;
}
